const stickyAddToCartButton = document.querySelector('.Product__FixedCartButton');
const staticAddToCartButton = document.getElementById('product-detail-submit-button');


const callback = (entries, observer) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      stickyAddToCartButton.classList.remove('Product__FixedCartButton--Visible');
    } else {
      stickyAddToCartButton.classList.add('Product__FixedCartButton--Visible');
    }
  });
};

const addToCartObserver = new IntersectionObserver(callback, {
  root: null,
  rootMargin: '-140px',
  threshold: 0.1
});


window.addEventListener('DOMContentLoaded', () => {
  addToCartObserver.observe(staticAddToCartButton);
});